import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const safeGet = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const safeSet = (k, v) => { try { localStorage.setItem(k, v); } catch {} };
const safeDel = (k) => { try { localStorage.removeItem(k); } catch {} };

const api = axios.create({
  baseURL: API,
});

const token = safeGet("ab_token");
if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export const setToken = (t) => {
  if (t) {
    safeSet("ab_token", t);
    api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
  } else {
    safeDel("ab_token");
    delete api.defaults.headers.common["Authorization"];
  }
};

export default api;
